import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';

const AnswerProgramming = forwardRef((props, ref) => {

    const [correct, setCorrect] = useState("");
    
    useEffect(() => {
        //console.log(props.answer)

        const  questionResponse = props.answer.A_3 != null ? props.answer.A_3.toLowerCase().trim() : "";
        const  candidateResponse = props.answer.R_1_Text != null ? props.answer.R_1_Text.toLowerCase().trim() : "";
        

        if (questionResponse != "" && questionResponse == candidateResponse) 
            setCorrect("Correct");

        if (questionResponse != "" && questionResponse != candidateResponse) 
            setCorrect("Wrong");

    }, []); 
        
    return (
    <>
        <b>Answer: <span className={"rounded px-1 py-1 " + (correct=='Wrong' ? 'bg-red-300 text-red-800' : '') +  (correct=='Correct' ? ' bg-green-300 text-green-800' : '')}>{correct}</span></b>
        <br /><br />
        <b>Code:</b> <br />
        <span className='whitespace-pre-line'>
        <code>{props.answer.R_Text}</code>
        </span>
        <br /><br />
        <b>Output:</b>  <br />
        {props.answer.R_1_Text !=null ? props.answer.R_1_Text  : ""}

    </>
    );
});


export default AnswerProgramming;